var _circle, _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 54,
    stroke: "url(#paint0_linear_4031_14044)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 4.13357,
    strokeLinecap: "round",
    strokeDasharray: "30 16 10 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 10.4762C32.6496 10.4762 10.4766 32.6494 10.4766 60.0005C10.4766 87.3505 32.6493 109.523 60.0001 109.523C87.3509 109.523 109.524 87.3505 109.524 60.0005C109.524 32.6494 87.3507 10.4762 60.0001 10.4762Z",
    fill: "url(#paint1_linear_4031_14044)",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4031_14044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7845 60.0003C92.7845 78.1068 78.1067 92.784 60.0002 92.784C41.8943 92.784 27.2158 78.1068 27.2158 60.0003C27.2158 41.8938 41.8943 27.2159 60.0002 27.2159C78.1067 27.2159 92.7845 41.8938 92.7845 60.0003Z",
    fill: "url(#paint2_linear_4031_14044)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5554 75.5423H51.5942C49.1924 75.5423 47.2819 74.3735 45.5666 72.7394C42.0552 69.394 47.8205 66.7205 50.0193 65.4112C53.7482 63.1909 58.2022 62.5762 62.3325 63.5673",
    stroke: "url(#paint3_linear_4031_14044)",
    strokeWidth: 2.22886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9948 51.4519C66.9948 55.3146 63.8635 58.4459 60.0008 58.4459C56.1382 58.4459 53.0068 55.3146 53.0068 51.4519C53.0068 47.5892 56.1382 44.4579 60.0008 44.4579C63.8635 44.4579 66.9948 47.5892 66.9948 51.4519Z",
    stroke: "url(#paint4_linear_4031_14044)",
    strokeWidth: 2.22886
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2178 75.5424L70.8804 70.8797M70.8804 70.8797L75.5431 66.217M70.8804 70.8797L66.2178 66.217M70.8804 70.8797L75.5431 75.5424",
    stroke: "url(#paint5_linear_4031_14044)",
    strokeWidth: 2.22886,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4031_14044",
    x: 12.3568,
    y: 12.3569,
    width: 95.2865,
    height: 95.2861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.42953
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4031_14044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4031_14044",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4031_14044",
    x1: 6,
    y1: 11.4,
    x2: 130.654,
    y2: 39.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#16EB78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4031_14044",
    x1: 10.4766,
    y1: 15.4285,
    x2: 124.797,
    y2: 40.8562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#16EB78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4031_14044",
    x1: 60.0002,
    y1: 27.2159,
    x2: 60.0002,
    y2: 92.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DEFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4031_14044",
    x1: 44.459,
    y1: 63.7302,
    x2: 64.1012,
    y2: 70.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4031_14044",
    x1: 53.0068,
    y1: 45.1573,
    x2: 69.1518,
    y2: 48.7483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4031_14044",
    x1: 66.2178,
    y1: 66.6833,
    x2: 76.9811,
    y2: 69.0773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.034c7ab28b8bcd17a2a98094a2ab4a8c.svg";
export { ForwardRef as ReactComponent };